// extracted by mini-css-extract-plugin
export var alertIcon = "_m8-0";